exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a[data-v-239ba2ec]{text-decoration:none}.route-card>.route-card-link[data-v-239ba2ec],.route-card[data-v-239ba2ec]{display:inline-flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-239ba2ec","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Home.vue
// module id = 403
// module chunks = 0